export default "__VITE_ASSET__e06f5b03__"